import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'sidebar-state',
  storage: localStorage
})

export default new Vuex.Store({
  state: {
    collapsed: false
  },
  mutations: {
    collapsed (state, collapsed) {
      state.collapsed = collapsed
    }
  },
  actions: {
    collapsed ({ commit }, payload) {
      return new Promise((resolve) => {
        commit('collapsed', payload)
        resolve()
      })
    }
  },
  getters: {
    collapsed: state => state.collapsed
  },
  plugins: [vuexPersist.plugin]
})
